export class DataModelGetFactures {
    constructor() {
        this.dateDebut = new Date()
        this.dateDebut.setMonth(new Date().getMonth() - 1)
    }
    public dateDebut: Date = new Date()
    public dateFin: Date = new Date()
}